module.exports = __webpack_public_path__ + "static/icons/snowing@3x-59b405b669322f2a27db7cf5c84347b6.png";